import {Component, OnDestroy, OnInit} from '@angular/core';
import {ModelDetail} from '@interface/model-detail/model-detail';
import {ModelElement} from '@interface/model-items/model-element';
import {ActivatedRoute, Router} from '@angular/router';
import {CatalogService} from '@service/catalog/catalog.service';
import {HeaderService} from '@service/header/header.service';
import {ModelService} from '@service/model/model.service';
import {CommonService} from '@service/common/common.service';
import {HeaderStep} from '@enum/header.step';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {OrderService} from '@service/order/order.service';
import {NavigationService} from '@service/navigation/navigation.service';

@Component({
    selector: 'app-model-detail-list',
    templateUrl: './model-detail-list.component.html',
    styleUrls: ['./model-detail-list.component.scss'],
    standalone: false
})
export class ModelDetailListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();
  public catalog: any = {};
  public overflow = true;
  public loaded = false;
  public productId: string | undefined;
  public categoryId: string | undefined;
  public model: ModelDetail | null = null;
  public modelElements: ModelElement[] | null = null;
  public eto: any = null;
  public filteredItems: any = null;
  public searchText: any = null;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
              private catalogService: CatalogService, private headerService: HeaderService,
              private modelService: ModelService, private common: CommonService,
              private navigation: NavigationService,
              private orderService: OrderService) {
  }

  ngOnInit(): void {
    this.headerService.header.next(HeaderStep.MODEL_TECHNICAL);
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params: any) => {
      if (params?.id) {
        this.productId = params?.id;
      }
      if (+params?.categoryId) {
        this.categoryId = params?.categoryId;
      }
    });
    const parameters = {modelId: Number(this.productId), categoryId: Number(this.categoryId)};
    this.modelService.modelDetail(parameters).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data?.error) {
        this.common.showErrorToast(data?.error);
      } else {
        this.model = data?.productModel;
      }
    });
    this.modelService.modelItems(parameters).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data?.error) {
        this.common.showErrorToast(data?.error);
      } else {
        this.eto = data?.modelEto;
        this.modelElements = data?.modelItems;
        this.assignCopy();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  public assignCopy(): void {
    this.filteredItems = Object.assign([], this.modelElements);
    this.loaded = true;
  }

  public modelDetail(): void {
    if (this.productId && this.categoryId) {
      this.headerService.header.next(HeaderStep.MODEL);
      this.router.navigate(['model-detail', String(this.productId), String(this.categoryId)]);
    }
  }

  public convertProductImage(model: any): string {
    return this.common.convertProductImage(model?.imagePath);
  }

  public catalogList(): void {
    this.navigation.goToCatalogList(false);
  }

  public goToModelDetailGrid(): void {
    this.router.navigate(
      ['model-detail-grid', this.productId, this.categoryId]
        .filter((x) => x)
        .map((x) => String(x))
    );
  }

  public customModel(): void {

  }

  public configureModelElement(modelElement: ModelElement): void {
    this.headerService.header.next(HeaderStep.CONFIGURATION);
    this.router.navigate(['model-configuration', String(modelElement.productId)]);
  }

  public filterItem(value: any): void {
    if (!value) {
      this.assignCopy();
    }
    this.filteredItems = Object.assign([], this.modelElements).filter((item: any) => {
      const code = item?.productCode;
      const finalName = item?.productName.concat('-' + code);
      return finalName.toLowerCase().indexOf(value.toLowerCase()) > -1;
    });
  }

  public isCopyingConfiguration(): boolean {
    return !!this.orderService.copyConfigurationId;
  }

  public cancelCopyingConfiguration(): void {
    this.orderService.copyConfigurationId = null;
  }

}
